/* @flow */
import type { 
    AddQuestion,MemEmpDetail,
    InputFormData,ApplicationDetail,
    Coverage,ApplicationInfo,
    PhysicianInfo,FormQuestion,
    InputFormQuestion,SubmitPayload,
    Dispatch,EditFormData,ReducerState
} from './flowTypes'
import { stringDate2MomentObject } from '../../Utils/dateUtil'
import { YES_ANSWER,NO_ANSWER } from '../../views/ProjectGorgon/common/variables'

const EDIT_DATE_FORMAT='YYYY-MM-DD'

const transformDataToEditAdditionalQuestions=(formData:EditFormData,data:any)=>{
    const additionalQuestions = data['additional_questions']
    if (additionalQuestions){
        if (additionalQuestions['applicantSignatureDate']){
            formData.applicantSignatureDate = stringDate2MomentObject(additionalQuestions['applicantSignatureDate'],EDIT_DATE_FORMAT)
        }
        formData.heightFeet = additionalQuestions['heightFeet']
        formData.heightInches = additionalQuestions['heightInches']
        formData.weight = additionalQuestions['weight']
        formData.isThereApplicantSignature = additionalQuestions['isThereApplicantSignature']
        formData.isOverrideApplicantSignatureDateNotFound=additionalQuestions['isOverrideApplicantSignatureDateNotFound']
    }
    return formData
}

const transformDataToEditPhysicianInformation=(formData:EditFormData,data:any)=>{
    const physicianInfo = data['physician_info']
    if (physicianInfo){
        if (physicianInfo['lastConsultDate']){
            formData.lastConsultDate = stringDate2MomentObject(physicianInfo['lastConsultDate'],EDIT_DATE_FORMAT)
        }
        formData.lastConsultReason = physicianInfo['lastConsultReason']
        formData.physicianAddrLine1 = physicianInfo['physicianAddrLine1']
        formData.physicianAddrLine2 = physicianInfo['physicianAddrLine2']
        formData.physicianCity = physicianInfo['physicianCity']
        formData.physicianClinicName = physicianInfo['physicianClinicName']
        formData.physicianFirstName = physicianInfo['physicianFirstName']
        formData.physicianLastName = physicianInfo['physicianLastName']
        formData.physicianPhoneNum = physicianInfo['physicianPhoneNum']
        formData.physicianState = physicianInfo['physicianState']
        formData.physicianZip = physicianInfo['physicianZip']
    }

    return formData
}

const transformDataToEditMemberEmployeeDetail=(formData:EditFormData,data:any)=>{
    const memEmpDetail = data['member_employee_detail']
    if (memEmpDetail){
        formData.isOverrideMemEmpCheckWhoIsApply = memEmpDetail['isOverrideMemEmpCheckWhoIsApply']
        formData.isOverrideMemEmpFirstNameNotFound = memEmpDetail['isOverrideMemEmpFirstNameNotFound']
        formData.isOverrideMemEmpLastNameNotFound = memEmpDetail['isOverrideMemEmpLastNameNotFound']
        if (memEmpDetail['memEmpBirthdate']){
            formData.memEmpBirthdate = stringDate2MomentObject(memEmpDetail['memEmpBirthdate'],EDIT_DATE_FORMAT)
        }
        formData.memEmpCheckWhoIsApply = memEmpDetail['memEmpCheckWhoIsApply']
        if (memEmpDetail['memEmpDatehired']){
            formData.memEmpDatehired = stringDate2MomentObject(memEmpDetail['memEmpDatehired'],EDIT_DATE_FORMAT)
        }
        formData.memEmpFirstName = memEmpDetail['memEmpFirstName']
        formData.memEmpGroupNumber = memEmpDetail['memEmpGroupNumber']
        formData.memEmpIdentificationNum = memEmpDetail['memEmpIdentificationNum']
        formData.memEmpLastName = memEmpDetail['memEmpLastName']
        formData.memEmpMiddleName = memEmpDetail['memEmpMiddleName']
        formData.memEmpNameOfAgency = memEmpDetail['memEmpNameOfAgency']
        formData.memEmpNameOfGroup = memEmpDetail['memEmpNameOfGroup']
        formData.memEmpNameSuffix = memEmpDetail['memEmpNameSuffix']
        formData.memEmpOccupation = memEmpDetail['memEmpOccupation']
        formData.memEmpSSN = memEmpDetail['memEmpSSN']
        formData.memEmpSalary = memEmpDetail['memEmpSalary']
    }
    return formData
}

const transformDataToEditApplicationDetail=(formData:EditFormData,data:any)=>{
    const applicationDetail = data['applicant_detail']
    if (applicationDetail){
        if (applicationDetail['appBirthdate']){
            formData.appBirthdate  = stringDate2MomentObject(applicationDetail['appBirthdate'],EDIT_DATE_FORMAT)
        }
        formData.appBirthplaceCountry = applicationDetail['appBirthplaceCountry']
        formData.appBirthplaceState = applicationDetail['appBirthplaceState']
        formData.appCity = applicationDetail['appCity']
        formData.appCountry = applicationDetail['appCountry']
        formData.appEmail = applicationDetail['appEmail']
        formData.appFirstName = applicationDetail['appFirstName']
        formData.appHomePhoneExt = applicationDetail['appHomePhoneExt']
        formData.appHomePhoneNum = applicationDetail['appHomePhoneNum']
        formData.appLastName = applicationDetail['appLastName']
        formData.appMiddleName = applicationDetail['appMiddleName']
        formData.appNameSuffix = applicationDetail['appNameSuffix']
        formData.appSSN = applicationDetail['appSSN']
        formData.appSex = applicationDetail['appSex']
        formData.appState = applicationDetail['appState']
        formData.appStreetAddrLine1 = applicationDetail['appStreetAddrLine1']
        formData.appStreetAddrLine2 = applicationDetail['appStreetAddrLine2']
        formData.appWorkPhoneExt = applicationDetail['appWorkPhoneExt']
        formData.appWorkPhoneNum = applicationDetail['appWorkPhoneNum']
        formData.appZip = applicationDetail['appZip']
        formData.isOverrideAppBirthplaceCountry = applicationDetail['isOverrideAppBirthplaceCountry']
        formData.isOverrideAppCityNotFound = applicationDetail['isOverrideAppCityNotFound']
        formData.isOverrideAppCountry = applicationDetail['isOverrideAppCountry']
        formData.isOverrideAppFirstNameNotFound = applicationDetail['isOverrideAppFirstNameNotFound']
        formData.isOverrideAppHomePhoneNumNotFound = applicationDetail['isOverrideAppHomePhoneNumNotFound']
        formData.isOverrideAppLastNameNotFound = applicationDetail['isOverrideAppLastNameNotFound']
        formData.isOverrideAppSexNotFound = applicationDetail['isOverrideAppSexNotFound']
        formData.isOverrideAppStateNotFound = applicationDetail['isOverrideAppStateNotFound']
        formData.isOverrideAppStreetAddrLine1NotFound = applicationDetail['isOverrideAppStreetAddrLine1NotFound']
        formData.isOverrideAppWorkPhoneNumNotFound = applicationDetail['isOverrideAppWorkPhoneNumNotFound']
        formData.isOverrideAppZipNotFound = applicationDetail['isOverrideAppZipNotFound']
    }
    
    return formData
}

const transformDataToEditApplicationInfo=(formData:EditFormData,data:any)=>{
    const applicationInfo = data['application_info']
    if (applicationInfo){
        formData.appInfoApplicationType = applicationInfo['appInfoApplicationType']
        const coverages:Array<Coverage> = applicationInfo.coverages
        
        let formAppCoverages = []
        let formId = 1
        coverages.map(coverage => {
            const planNameElementId = `appInfoCoverageRequested${formId}`
            const currentAmountElementId = `appInfoCurrentAmtInForce${formId}`
            const additionalAmountElementId = `appInfoAdditionalAmtReq${formId}`
            const totalAmountElementId = `appInfoTotalAmtReq${formId}`

            formData[planNameElementId] = coverage.planName
            formData[currentAmountElementId] = coverage.currentAmount
            formData[additionalAmountElementId] = coverage.additionalAmount
            formData[totalAmountElementId] = coverage.totalAmount

            let form = {
                formId: formId
            }
            formAppCoverages.push(form)

            formId += 1
        })
        
        formData.formAppCoverages = formAppCoverages
    }
    return formData
}

export const transformDataToEditMedicalHistoryQuestions=(formData:EditFormData,changeFieldValue:any)=>{
    const medicalHistoryQuestions = formData.medicalHistoryQuestions

    if (medicalHistoryQuestions && medicalHistoryQuestions.length > 0) {
        medicalHistoryQuestions.map(question =>{
            const { id, responseData } = question

            if (responseData){
                const yesNoVariable = responseData==='Y'?YES_ANSWER:NO_ANSWER
                const questionElement=`${yesNoVariable}${id}`
                changeFieldValue(questionElement,true)
            }
        })
    }
}

export const transformFormDataToEditMode=(data:any,gorgon: ReducerState)=>{
    let formData: EditFormData = {}
    if (data['form_num']){
        formData.formNum = data['form_num']
    }
    formData.isDocInvalid = data['is_doc_invalid']
    formData.isDocNotLoad = data['is_doc_not_load']
    formData.isNoFormNumInDoc = data['is_no_form_num_in_doc']
    formData.isOverrideFormNum = data['is_override_form_num']
    formData.medicalHistoryQuestions = (data['medical_history_questions']:Array<any>)

    formData = transformDataToEditPhysicianInformation(formData,data)
    formData = transformDataToEditAdditionalQuestions(formData,data)
    formData = transformDataToEditMemberEmployeeDetail(formData,data)
    formData = transformDataToEditApplicationDetail(formData,data)
    formData = transformDataToEditApplicationInfo(formData,data)

    return formData
}


// WEBPACK FOOTER //
// ./src/redux/gorgon/editFormData.js